import { FC } from 'react';

type Props = { required?: boolean };

const RequiredAsterisk: FC<Props> = ({ required }) => {
  return required ? <span className="tw:text-brand-300 tw:ml-1">*</span> : null;
};

export default RequiredAsterisk;
